import _extends from '@babel/runtime-corejs3/helpers/extends';
import React__default, { forwardRef } from 'react';
import classNames from 'classnames';
import '../index.js';
import '../../icons/index.es.js';
import '../../utils/index.js';
import { bannerVariant, bannerContainer, banner, noIcon, dismissible, closeButton, icon, copy, title, description, bannerFooter } from './Banner.css.js';
import InformationIcon from '../../icons/components/InformationIcon.js';
import WarningIcon from '../../icons/components/WarningIcon.js';
import ErrorIcon from '../../icons/components/ErrorIcon.js';
import SuccessIcon from '../../icons/components/SuccessIcon.js';
import useTranslation from '../../utils/Translation/useTranslation.js';
import IconButton from '../IconButton/IconButton.js';
import getSubDataTestId from '../../utils/getSubDataTestId/getSubDataTestId.js';
import CloseIcon from '../../icons/components/CloseIcon.js';

const BannerTitle = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children);
};
const BannerBody = _ref2 => {
  let {
    children
  } = _ref2;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children);
};
const BannerFooter = _ref3 => {
  let {
    children
  } = _ref3;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children);
};
const statusIconMap = {
  info: InformationIcon,
  warn: WarningIcon,
  error: ErrorIcon,
  success: SuccessIcon
};
const Banner = /*#__PURE__*/forwardRef((_ref4, ref) => {
  let {
    onClose,
    icon: icon$1,
    status,
    'data-testid': dataTestId,
    children,
    ...rest
  } = _ref4;
  let title$1;
  let footer;
  let content;
  let IconUsed = icon$1;
  const {
    translate
  } = useTranslation();
  React__default.Children.forEach(children, child => {
    if (! /*#__PURE__*/React__default.isValidElement(child)) return;
    if (child.type === BannerTitle) {
      title$1 = child;
    } else if (child.type === BannerFooter) {
      footer = child;
    } else if (child.type === BannerBody) {
      content = child;
    }
  });
  if (status && !icon$1) {
    IconUsed = statusIconMap[status];
  }
  const variant = status ? bannerVariant[status] : false;
  const handleClose = onClose ? () => {
    onClose();
  } : () => {};
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: bannerContainer,
    "data-testid": dataTestId
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React__default.createElement("div", {
    className: classNames(banner, variant, {
      [noIcon]: !status && !icon$1,
      [dismissible]: !!onClose
    })
  }, !!onClose && /*#__PURE__*/React__default.createElement(IconButton, {
    className: closeButton,
    onClick: handleClose,
    "aria-label": translate('close'),
    "data-testid": getSubDataTestId(dataTestId, 'close')
  }, /*#__PURE__*/React__default.createElement(CloseIcon, null)), !!IconUsed && /*#__PURE__*/React__default.createElement("div", {
    className: icon
  }, /*#__PURE__*/React__default.createElement(IconUsed, {
    "data-testid": getSubDataTestId(dataTestId, 'icon'),
    "aria-hidden": true
  })), /*#__PURE__*/React__default.createElement("div", {
    className: copy
  }, !!title$1 && /*#__PURE__*/React__default.createElement("div", {
    className: title,
    "data-testid": getSubDataTestId(dataTestId, 'title')
  }, title$1), /*#__PURE__*/React__default.createElement("div", {
    className: description,
    "data-testid": getSubDataTestId(dataTestId, 'body')
  }, content), !!footer && /*#__PURE__*/React__default.createElement("div", {
    className: bannerFooter,
    "data-testid": getSubDataTestId(dataTestId, 'footer')
  }, footer))));
});

export { Banner, BannerBody, BannerFooter, BannerTitle };
